import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifictaion',
  templateUrl: './notifictaion.component.html',
  styleUrls: ['./notifictaion.component.css']
})
export class NotifictaionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
